export const
      ACTIVITIES_PREPARE = 'ACTIVITIES_PREPARE',
      ACTIVITIES_REQUEST = 'ACTIVITIES_REQUEST',
      SEND_ACTIVITY = 'SEND_ACTIVITY',
      ACTIVITIES_BOTTOM_REACHED = 'ACTIVITIES_BOTTOM_REACHED'

